export enum ETransportLiterals {
    metro = "Metro",
    ave = "AVE Larga distancia",
    bici = "Bici",
    busUrb = "Autobús urbano",
    cooltra = "Cooltra",
    reby = "Reby",
    taxi = "Movitaxi",
    karhoo = "Taxi/VTC",
    cercanias = "Cercanias",
    bolt = "Bolt",
    avant = "AVANT",
    tier="Tier",
    renfe="RENFE",
    freenow="Freenow"
  } 

  export interface IBodyTripSelectedDetails {
    transport?: string;
  }

  
export interface DataPromoCode {
  voucherCode: string;
  voucherAmount:number;
  discountType:string;
  isValid:boolean;
}

export interface PostDataPromo{
    id: string,
    code: string,
    amount: number

}